import React from 'react';
// reactstrap components
import { Button, NavItem, NavLink, Nav, Container, Row, Col, UncontrolledTooltip } from 'reactstrap';
class SimpleFooter extends React.Component {
	render() {
		return (
			<>
				<footer className=" footer">
					<Container>
						<Row className=" row-grid align-items-center mb-5">
							<Col lg="6">
								<h6 className="mb-0 font-weight-bold">Hitung cepat ini berdasarkan Form C1 pada TPS</h6>
							</Col>
							<Col className="text-lg-center btn-wrapper" lg="6">
								<Button
									className="btn-icon-only rounded-circle"
									color="twitter"
									href="#"
									id="tooltip475038074"
									target="_blank"
									rel="noopener noreferrer"
								>
									<span className="btn-inner--icon">
										<i className="fa fa-twitter" />
									</span>
								</Button>
								<UncontrolledTooltip delay={0} target="tooltip475038074">
									Follow us
								</UncontrolledTooltip>
								<Button
									className="btn-icon-only rounded-circle ml-1"
									color="facebook"
									href="#"
									id="tooltip837440414"
									target="_blank"
									rel="noopener noreferrer"
								>
									<span className="btn-inner--icon">
										<i className="fa fa-facebook-square" />
									</span>
								</Button>
								<UncontrolledTooltip delay={0} target="tooltip837440414">
									Like us
								</UncontrolledTooltip>
								<Button
									className="btn-icon-only rounded-circle ml-1"
									color="dribbble"
									href="#"
									id="tooltip829810202"
									target="_blank"
									rel="noopener noreferrer"
								>
									<span className="btn-inner--icon">
										<i className="fa fa-dribbble" />
									</span>
								</Button>
								<UncontrolledTooltip delay={0} target="tooltip829810202">
									Follow us
								</UncontrolledTooltip>
								<Button
									className="btn-icon-only rounded-circle ml-1"
									color="success"
									href="#"
									id="tooltip495507257"
									target="_blank"
									rel="noopener noreferrer"
								>
									<span className="btn-inner--icon">
										<i className="fa fa-whatsapp" />
									</span>
								</Button>
								<UncontrolledTooltip delay={0} target="tooltip495507257">
									Whatsapp
								</UncontrolledTooltip>
							</Col>
						</Row>
						<hr />
						<Row className=" align-items-center justify-content-md-between">
							<Col md="6">
								<div className=" copyright">
									© 2020{' '}
									<a
										href="https://facebook.com/arfadly.tongkukut"
										target="_blank"
										rel="noopener noreferrer"
									>
										#BeSmartPeople
									</a>
									.
								</div>
							</Col>
							<Col md="6">
								<Nav className=" nav-footer justify-content-end">
									<NavItem>
										<NavLink href="https://facebook.com/arfadly.tongkukut" target="_blank">
											Coding With <i className="fa fa-heart text-danger"></i> by Anak Kampung
										</NavLink>
									</NavItem>
								</Nav>
							</Col>
						</Row>
					</Container>
				</footer>
			</>
		);
	}
}

export default SimpleFooter;
